import { render, staticRenderFns } from "./mentionTab.vue?vue&type=template&id=457692c5&scoped=true&"
import script from "./mentionTab.vue?vue&type=script&lang=ts&"
export * from "./mentionTab.vue?vue&type=script&lang=ts&"
import style0 from "./mentionTab.vue?vue&type=style&index=0&id=457692c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457692c5",
  null
  
)

export default component.exports